<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Accounts Details</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap v-if="details">
      <v-flex md4 class="pa-4">
        <div>
          <strong>Service Charge</strong><br />
          <p>Tk. {{serviceCharge}}</p>
        </div>
        <div>
          <strong>Received</strong><br />
          <p>Tk. {{totalReceived}}</p>
        </div>
      </v-flex>
      <v-flex md4 class="pa-4">
        <div>
          <strong>Expense</strong><br />
          <p>Tk. {{totalExpense}}</p>
        </div>
        <div>
          <strong>Due</strong><br />
          <p>Tk. {{ serviceCharge - totalReceived}}</p>
        </div>
      </v-flex>
      <v-flex md4 class="pa-4">
        <div>
          <strong>Balance On</strong><br />
          <p>Tk. {{ serviceCharge - totalExpense}}</p>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { columnSum } from "../../mdsir/MdsirUtils";
export default {
  props: ["details"],
  // data() {
  //   return {
  //     // relatedFiles: [],
  //   };
  // },

  computed: {
    serviceCharge(){
      const { project } = this.details;
      return project ? project.service_charge : 0;
    },
    totalReceived(){
      const { receives } = this.details;
      let sum = 0;
      if(receives && receives.length > 0){
        sum = columnSum(receives, 'amount');
      }
      return sum;
    },
    totalExpense(){
      const { payments } = this.details;
      let sum = 0;
      if(payments && payments.length > 0){
        sum = columnSum(payments, 'amount');
      }
      return sum;
    }
  },

  // methods: {},

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
